import { type RouteRecordRaw } from "vue-router";
import { canAccess, haveOneAccess, permissionList } from "@/utilities/authorization";

const customerRoutes: RouteRecordRaw[] = [
    {
        name: 'customer-navigation',
        path: '/customer/navigation',
        component: () => import('@/views/customer/CustomerNavigation.vue'),
        beforeEnter: () => haveOneAccess([
            permissionList.READ_CUSTOMER,
            permissionList.CREATE_CUSTOMER
        ]) ? true : { name: 'dashboard' },
    },
    {
        name: 'customer',
        path: '/customer',
        component: () => import('@/views/customer/CustomerIndex.vue'),
        beforeEnter: () => canAccess(permissionList.READ_CUSTOMER) ? true : { name: 'customer-navigation' },
    },
    {
        name: 'customer-new',
        path: '/customer/new',
        component: () => import('@/views/customer/NewCustomer.vue'),
        beforeEnter: () => canAccess(permissionList.CREATE_CUSTOMER) ? true : { name: 'customer-navigation' },
    },
    {
        name: 'customer-update',
        path: '/customer/update/:id(\\d+)',
        component: () => import('@/views/customer/UpdateCustomer.vue'),
        beforeEnter: () => canAccess(permissionList.UPDATE_CUSTOMER) ? true : { name: 'customer-navigation' },
    },
    {
        name: 'customer-detail',
        path: '/customer/:id(\\d+)',
        component: () => import('@/views/customer/DetailCustomer.vue'),
        beforeEnter: () => canAccess(permissionList.READ_CUSTOMER) ? true : { name: 'customer-navigation' },
    },
]

export default customerRoutes
